<template>
<div>
	<div v-if="show" class="c-tabs">
		<v-select
			v-if="mobileView"
			:label="label"
			:id="selectId"
			:visible-label='false'
			:selected='selectedSelectIndex'
			:options='tabsMobile'
			@optionSelected="e => handleClick(e)">
		</v-select>
		<div v-else class="c-tabs__list" :aria-label="label" role="tablist">
			<!-- This div below had s-light in empty '' -->
			<div class="c-tabs__item"
				s-light=""
				:class="{ 'c-tabs__item--active ' : currentTab === tab, '' : currentTab != tab}"
				v-for="(tab, index) in tabs"
				v-if="tab !== 'default'"
				:key="index">
				<!-- this button had c-button class. -->
				<button
					class="c-tabs-button c-button--reset c-button--noboxshadow c-tabs__title"
					:id="'tab' + index"
					type="button"
					role="tab"
					@click.prevent="handleClick(tab)"
					:aria-selected="currentTab === tab ? true : false"
					:aria-controls="currentTab === tab ? 'tabpanel' + index : null">{{tab}}</button>
			</div>
		</div>
	</div>
	<div v-if="currentTab === tab"
		:id="'tabpanel' + index"
		class="c-tabs__tab-content"
		v-for="(tab, index) in tabs"
		:key="tab"
		role="tabpanel"
		:aria-labelledby="'tab' + index">
		<slot :name="tab"></slot>
	</div>
</div>
</template>
<script>
import VSelect from '../../components/form-elements/select/VSelect.vue';
export default {
    name: 'VTabs',
    props: {
		show: {
			type: Boolean,
			default: true,
		},
		label: {
			type: String,
			default: 'Visa nuvarande sida vald'
		},
		selectId: {
			type: String,
			default: 'tabs_select'
		}
	},
	components: {
		VSelect
	},
    data: () => ({
		currentTab: '',
		mobileView: false,
		selectedSelectIndex: 0
	}),
    methods: {
		handleClick(tab) {
			if(tab && tab.display) {
				this.currentTab = tab.display;
				this.selectedSelectIndex = tab.value;
			} else {
				this.currentTab = tab;
			}
		},
		onResize() {
			if (window.innerWidth < 600) {
				this.mobileView = true;
			} else {
				this.mobileView = false;
			}
		}
	},
	computed: {
		tabs() {
			return Object.keys(this.$slots);
		},
		tabsMobile() {
			let tabs = this.tabs.map((tab, index) => (
				{
					value: index,
					display: tab,
				}
			));
			return tabs.filter(t => t.display !== 'default');
		}
	},
    created() {
		this.currentTab = this.tabs[0];
		window.addEventListener('resize', this.onResize);
		if(window.innerWidth < 600) {
			this.onResize();
		}
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize)
	},
}
</script>
